import { useMutation, useQueryClient } from '@tanstack/react-query';
import { handleError } from '../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../shared/types';
import { showSuccessNotification } from '../../../../ui/notification';
import { queries } from '../../../../../shared/queries';
import { prodoqApis } from '../../../../../shared/apis/prodoq/apis';

export default function usePutRole() {
  const queryClient = useQueryClient();
  return useMutation(prodoqApis.putRole, {
    onSuccess: () => {
      showSuccessNotification('수정 성공', '역할 수정에 성공하였습니다.');
      queryClient.invalidateQueries({ queryKey: queries.prodoq.roles._def });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });
}
